import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5d23158"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sign-up--full-name" }
const _hoisted_2 = { class: "u-s-n" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Accept ")
const _hoisted_4 = ["href"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Already have account? ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Log In")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_IconService = _resolveComponent("IconService")!
  const _component_NAICSCode = _resolveComponent("NAICSCode")!
  const _component_base_checkbox = _resolveComponent("base-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_base_input, {
        class: "m-right-20",
        title: "First Name",
        bind: { autocomplete: 'given-name' },
        errors: _ctx.formErrors.first_name,
        value: _ctx.form.first_name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.first_name) = $event))
      }, null, 8, ["errors", "value"]),
      _createVNode(_component_base_input, {
        title: "Last Name",
        bind: { autocomplete: 'family-name' },
        errors: _ctx.formErrors.last_name,
        value: _ctx.form.last_name,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.last_name) = $event))
      }, null, 8, ["errors", "value"])
    ]),
    _createVNode(_component_base_input, {
      title: "Email Address",
      bind: { autocomplete: 'email' },
      errors: _ctx.formErrors.email,
      value: _ctx.form.email,
      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email) = $event))
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_IconService, {
          class: "base-input__icon--fill email",
          icon: "email"
        })
      ]),
      _: 1
    }, 8, ["errors", "value"]),
    _createVNode(_component_base_input, {
      title: "Phone Number",
      errors: _ctx.formErrors.phone_number,
      bind: { autocomplete: 'tel' },
      value: _ctx.form.phone_number,
      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.phone_number) = $event))
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_IconService, {
          class: "base-input__icon--stroke",
          icon: "phone"
        })
      ]),
      _: 1
    }, 8, ["errors", "value"]),
    _createVNode(_component_base_input, {
      title: "Company Name",
      errors: _ctx.formErrors.company_name,
      bind: { autocomplete: 'organization' },
      value: _ctx.form.company_name,
      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.company_name) = $event))
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_IconService, {
          class: "base-input__icon--stroke",
          icon: "clipboard"
        })
      ]),
      _: 1
    }, 8, ["errors", "value"]),
    _createVNode(_component_NAICSCode, {
      errors: _ctx.formErrors.naics_code,
      icon: "",
      onNaics: _ctx.handleNAICSTitle
    }, null, 8, ["errors", "onNaics"]),
    _createVNode(_component_base_input, {
      title: "Password",
      type: "password",
      bind: { autocomplete: 'new-password' },
      errors: _ctx.formErrors.password,
      value: _ctx.form.password,
      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.password) = $event))
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_IconService, {
          class: "base-input__icon--stroke",
          icon: "lock"
        })
      ]),
      _: 1
    }, 8, ["errors", "value"]),
    _createVNode(_component_base_checkbox, {
      value: _ctx.form.termsConditions,
      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.termsConditions) = $event)),
      errors: _ctx.formErrors.termsConditions
    }, {
      title: _withCtx(() => [
        _createElementVNode("p", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("a", {
            href: _ctx.footerLinks.privacy_policy,
            target: "_blank",
            rel: "noreferrer noopener"
          }, "Terms & Conditions", 8, _hoisted_4)
        ])
      ]),
      _: 1
    }, 8, ["value", "errors"]),
    _createElementVNode("button", {
      class: "btn fill t-t-u m-bottom-20",
      disabled: _ctx.loader,
      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.signUp && _ctx.signUp(...args)))
    }, "Sign Up", 8, _hoisted_5),
    _createElementVNode("p", null, [
      _hoisted_6,
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ])
  ], 64))
}